<mat-form-field class="flex-fill align-center" id="tenant-selector">
  <span matPrefix class="m-r-10">
    <fa-icon icon="building" size="lg"></fa-icon>
  </span>
  <mat-label>{{ 'labels.inputs.Tenant' | translate }}</mat-label>
  <mat-select [formControl]="tenantSelector" (selectionChange)="setTenantIdentifier()" class="tenantselector">
    @for (tenant of tenants; track tenant.identifier) {
      <mat-option [value]="tenant.identifier">
        {{ tenant.name }}
        <span class="tenant-identifier">({{ tenant.identifier }})</span>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
